const CURRENCY_FORMATTER = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
const DATE_FORMATTER = new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });

export const formatPrice = (value: number): string => CURRENCY_FORMATTER.format(value);

export function formatGroupDate(dateStr: string | undefined, fallback?: string, prefix = 'Le '): string {
    if (!dateStr || dateStr === 'no-date') return fallback ?? '';
    try {
        const [y, m, d] = dateStr.split('-').map(Number);
        const date = new Date(y, m - 1, d);

        if (isNaN(date.getTime())) {
            const dFallback = new Date(dateStr.includes('T') ? dateStr : dateStr + 'T00:00:00');
            if (isNaN(dFallback.getTime())) return dateStr;
            return `${prefix}${DATE_FORMATTER.format(dFallback)}`;
        }

        return `${prefix}${DATE_FORMATTER.format(date)}`;
    } catch {
        return dateStr ?? '';
    }
}
